/**
 * @module PhoneButton
 * @description
 */
import { useContext } from "react";
import Link from "next/link";
import { trackEvent } from "@/js/helpers/tracking";
import styles from "./DynamicButton.module.css";
import { formatPhoneNumber } from "@/js/helpers/fuse";
import { FuelContext } from "@/providers/fuel-provider";
import { DEFAULT_FUSE_NUMBER } from "@/js/constants/monarch";
import { stringify } from "@/js/utils/filters";

/**
 * @function PhoneButton
 * @description
 */
export const PhoneButton = ({ ...props }) => {
  const { altPhoneNumber, copy, isMobile } = props;
  const { fuseNumber } = useContext(FuelContext);
  const phoneNumber = altPhoneNumber || fuseNumber || DEFAULT_FUSE_NUMBER;

  delete props.href; // we need to remove the href prop otherwise we could end up going to cart
  const {
    position,
    children = (
      <>
        {`${copy || "CALL"}`}{" "}
        {isMobile && <span className="icon icon-phone-outline" />}
        {!isMobile && formatPhoneNumber(phoneNumber)}
      </>
    ),
  } = props;

  /**
   * @function handleClick
   * @description
   */
  const handleClick = (event) => {
    const { target } = event;
    const { actionOutcome } = JSON.parse(target.getAttribute("data-payload"));
    const data = {
      elementType: "BUTTON",
      position,
      text: `Phone Number ${formatPhoneNumber(phoneNumber)}`,
      actionOutcome: actionOutcome || "CLICKTOCALL",
    };

    trackEvent({ action: "elementClicked", data, event });
  };

  return (
    <Link
      href={`tel:${phoneNumber}`}
      onClick={handleClick}
      data-type="phone"
      data-payload={stringify({
        actionOutcome: "CLICKTOCALL",
        phoneNumber,
      })}
      className={`btn ${styles.component__btn}`}
      {...props}
    >
      {children}
    </Link>
  );
};

export default PhoneButton;
